// src/pages/admin/Payout.js
import React, { useState } from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  useTheme,
  alpha,
  Avatar,
  Badge
} from "@mui/material";
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
  MoreVert as MoreIcon,
  Payment as PaymentIcon,
  AccountBalance as BankIcon,
  Paypal as PaypalIcon,
  CreditCard as CreditCardIcon,
  CheckCircle as CompletedIcon,
  Pending as PendingIcon,
  Schedule as ScheduledIcon,
  Error as FailedIcon,
  Download as DownloadIcon,
  Refresh as RefreshIcon,
  Send as SendIcon,
} from "@mui/icons-material";

// Mock data for payouts
const mockPayouts = [
  {
    id: 1,
    cleaner: {
      name: "Maria Garcia",
      avatar: "",
      method: "bank",
      account: "****1234"
    },
    amount: 1250,
    date: "2024-03-20",
    status: "completed",
    method: "bank_transfer",
    reference: "PAY-001234",
    period: "Mar 13-19, 2024",
    jobs: 15,
    fees: 12.50
  },
  {
    id: 2,
    cleaner: {
      name: "James Wilson",
      avatar: "",
      method: "paypal",
      account: "james@example.com"
    },
    amount: 890,
    date: "2024-03-20",
    status: "completed",
    method: "paypal",
    reference: "PAY-001235",
    period: "Mar 13-19, 2024",
    jobs: 11,
    fees: 8.90
  },
  {
    id: 3,
    cleaner: {
      name: "Carlos Rodriguez",
      avatar: "",
      method: "bank",
      account: "****5678"
    },
    amount: 1560,
    date: "2024-03-21",
    status: "pending",
    method: "bank_transfer",
    reference: "PAY-001236",
    period: "Mar 13-19, 2024",
    jobs: 19,
    fees: 15.60
  },
  {
    id: 4,
    cleaner: {
      name: "Lisa Chen",
      avatar: "",
      method: "paypal",
      account: "lisa@example.com"
    },
    amount: 720,
    date: "2024-03-21",
    status: "scheduled",
    method: "paypal",
    reference: "PAY-001237",
    period: "Mar 13-19, 2024",
    jobs: 9,
    fees: 7.20
  },
  {
    id: 5,
    cleaner: {
      name: "Robert Smith",
      avatar: "",
      method: "bank",
      account: "****9012"
    },
    amount: 980,
    date: "2024-03-19",
    status: "failed",
    method: "bank_transfer",
    reference: "PAY-001238",
    period: "Mar 6-12, 2024",
    jobs: 12,
    fees: 9.80
  }
];

const StatusChip = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'completed':
        return { color: 'success', label: 'Completed', icon: <CompletedIcon /> };
      case 'pending':
        return { color: 'warning', label: 'Pending', icon: <PendingIcon /> };
      case 'scheduled':
        return { color: 'info', label: 'Scheduled', icon: <ScheduledIcon /> };
      case 'failed':
        return { color: 'error', label: 'Failed', icon: <FailedIcon /> };
      default:
        return { color: 'default', label: status, icon: null };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      icon={config.icon}
    />
  );
};

// const MethodIcon = ({ method }) => {
//   switch (method) {
//     case 'bank_transfer':
//       return <BankIcon color="primary" />;
//     case 'paypal':
//       return <PaypalIcon sx={{ color: '#0070BA' }} />;
//     case 'credit_card':
//       return <CreditCardIcon color="secondary" />;
//     default:
//       return <PaymentIcon color="action" />;
//   }
// };

export default function Payout() {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPayouts, setSelectedPayouts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterMethod, setFilterMethod] = useState('all');
  const [anchorEl, setAnchorEl] = useState(null);
  const [processDialogOpen, setProcessDialogOpen] = useState(false);

  const filteredPayouts = mockPayouts.filter(payout =>
    payout.cleaner.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    payout.reference.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelectedPayouts(filteredPayouts.map(p => p.id));
    } else {
      setSelectedPayouts([]);
    }
  };

  const handleClick = (event, id) => {
    const selectedIndex = selectedPayouts.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedPayouts, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedPayouts.slice(1));
    } else if (selectedIndex === selectedPayouts.length - 1) {
      newSelected = newSelected.concat(selectedPayouts.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedPayouts.slice(0, selectedIndex),
        selectedPayouts.slice(selectedIndex + 1),
      );
    }

    setSelectedPayouts(newSelected);
  };

  const isSelected = (id) => selectedPayouts.indexOf(id) !== -1;

  const stats = [
    { label: 'Total Payouts', value: '$12,540', change: '+8%' },
    { label: 'Pending', value: '$2,280', change: '+12%' },
    { label: 'This Week', value: '$5,400', change: '+15%' },
    { label: 'Avg. Payout', value: '$1,080', change: '+5%' },
  ];

  const pendingAmount = mockPayouts
    .filter(p => p.status === 'pending')
    .reduce((sum, p) => sum + p.amount, 0);

  return (
    <Box>
      
    </Box>
  );
}